import { render, staticRenderFns } from "./AcaoFluxo.vue?vue&type=template&id=6c03ec56&"
import script from "./AcaoFluxo.vue?vue&type=script&lang=js&"
export * from "./AcaoFluxo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/custom/abbrasil/spa/dashboard/cadeia/apuracao/pendencias/AcaoFluxo.vue
// module id = 1221
// module chunks = 28